<div class="login-container">

  <div class="main-wrapper" layout-align="center center">

    <mat-card class="box">

      <div class="card-head">
        <mat-card-header>
          <mat-card-title>
            <img class="logoImage" src="assets/img/LogoTransparent_LigBlou.png">
            <br>
            <div class="h3" style="margin-bottom: 0px;">Reset Password</div>
            <!-- <div class="ag-body-small-medium"
              style="text-align: center;margin-top: 14px; display: flex; flex-direction: row; justify-content: center; margin-bottom:30px ;">
              <div>Don't Have an account? </div>
              <div class="warnTextColor" style="margin-left: 4px; cursor: pointer;"> Create Account 1</div>
            </div> -->
          </mat-card-title>





        </mat-card-header>
      </div>

      <div>
        <mat-card-content>
          <form class="login-form">

            <!-- 
            <mat-form-field class="gate-full-width" appearance="standard" color="accent">
              <mat-label>Email address</mat-label>
              <input type="email" matInput [formControl]="emailFormControl">
              <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="emailFormControl.hasError('required')">
                Email is required
              </mat-error>
            </mat-form-field> -->



            <mat-form-field class="gate-full-width" appearance="standard" color="accent">
              <mat-label>Password</mat-label>
              <input [type]="hidePW1 ? 'password' : 'text'" matInput [formControl]="passwordFormControl">
              <mat-icon class="suffix-icon" matSuffix (click)="hidePW1 = !hidePW1">
                {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error *ngIf="passwordFormControl.hasError('required')">
                Password is required
              </mat-error>
              <mat-error *ngIf="passwordFormControl.hasError('minlength')">
                Minimum 8 characters
              </mat-error>
            </mat-form-field>

            <mat-form-field class="gate-full-width" appearance="standard" color="accent" style="float: right;">
              <mat-label>Retype Password</mat-label>
              <input [type]="hidePW3 ? 'password' : 'text'" matInput [formControl]="passwordRetypeFormControl">
              <mat-icon class="suffix-icon" matSuffix (click)="hidePW3 = !hidePW3">
                {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error *ngIf="passwordRetypeFormControl.hasError('required')">
                Password is required
              </mat-error>
              <mat-error *ngIf="passwordRetypeFormControl.hasError('minlength')">
                Minimum 8 characters
              </mat-error>
              <mat-error
                *ngIf="passwordRetypeFormControl.hasError('pattern') && !passwordRetypeFormControl.hasError('minlength')">
                Passwords do not match
              </mat-error>
            </mat-form-field>
          </form>
          <!-- <br> -->

          <!-- <div class="ag-body-medium"
            style="text-align: center;margin-top: 14px; display: flex; flex-direction: row; justify-content: left; margin-bottom:30px ;">
            <div>Forgot Password?</div>
            <div class="warnTextColor" style="margin-left: 4px; cursor: pointer;"> Reset
              Password</div>
          </div> -->
        </mat-card-content>

        <button mat-raised-button class="btn-block reset-button ag-body-medium" (click)="resetPassword()">Reset</button>

      </div>



    </mat-card>



  </div>
</div>
